import { Component, input } from '@angular/core';
import { ToolchainTimelineStep } from '../toolchain-timeline.types';

@Component({
  selector: 'app-toolchain-timeline-legend',
  templateUrl: './toolchain-timeline-legend.component.html',
  styleUrl: './toolchain-timeline-legend.component.scss',
})
export class ToolchainTimelineLegendComponent {
  /** Inputs. */
  readonly steps = input.required<ToolchainTimelineStep[]>();

  /** Scrolls the selected step into view. */
  scrollToStep(stepNo: number): void {
    document
      .getElementById(`toolchain-step-${stepNo}`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
